/**
 * Creates a hidden form with the given fields, submits it via POST, then removes it.
 * The form only exists in the DOM for the instant of submission — nothing persists.
 *
 * Usage:
 *   submitHiddenForm('/appUserLogin', {
 *       redirectUrl: 'https://...',
 *       loginApp: 'SSOS',
 *       samlSession: window.jspSamlSession  // undefined/null values are skipped
 *   });
 *
 * @param {string} action - The form action URL (e.g., '/appUserLogin', '/samlauth')
 * @param {Object} fields - Key-value pairs for hidden input fields. Entries with
 *                           undefined, null, or false values are excluded.
 */
export default function submitHiddenForm(action, fields) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = action;
    form.style.display = 'none';

    Object.entries(fields).forEach(([name, value]) => {
        if (value !== undefined && value !== null && value !== false) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = String(value);
            form.appendChild(input);
        }
    });

    document.body.appendChild(form);
    form.submit();
    // form.submit() triggers full-page navigation; DOM is discarded by the browser.
}
